import { diInject } from '@di/di';
export class WidgetAdApi {
    constructor(_env) {
        this.ad = diInject(0 /* Token.AD */);
        this.parameters = this.ad.parameters;
        this.customDomain = _env.CUSTOM_AD_DOMAIN;
    }
    trackCustomEvent(eventData) {
        this.ad.tracking.trackCustomEvent(eventData);
    }
    trackCustomProgressEvent(eventData) {
        if (eventData.value < 0 && eventData.value > 1) {
            throw new Error('Event value for custom progess events has to be between 0 and 1');
        }
        this.ad.tracking.trackCustomProgressEvent(eventData);
    }
}
